import { call, put, all } from 'redux-saga/effects';
import { sagaErrorHandle } from './sagasError';
import { CourseTypes as Types } from '../ducks/course';
import {
  updateLessonCompleted,
  fetchFiles,
  fetchQuestions,
} from '../../services/lesson';
import { fetchAnswers, postAnswer, updateAnswer } from '../../services/answers';
import { convertArrToObj } from '../../utils';
import { AddLog } from '../../services/log';

export function* setLessonCompleted(action) {
  const { courseId, lessonId, isCompleted } = action;
  yield put({
    type: Types.SET_LESSON_ERROR,
    errorType: 'lessonCompleted',
    error: false,
    course: courseId,
    lesson: lessonId,
  });
  try {
    yield call(updateLessonCompleted, { courseId, lessonId, isCompleted });
    yield put({
      type: Types.UPDATE_LESSON_COMPLETED,
      courseId,
      lessonId,
      isCompleted,
    });
    yield call(AddLog, { actionId: 5, lessonId });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'setLessonCompleted',
      errorData: error,
      additionalInfos: action,
    });
    yield put({
      type: Types.SET_LESSON_ERROR,
      errorType: 'lessonCompleted',
      error: { status, msg },
      course: courseId,
      lesson: lessonId,
    });
  }
}

export function* getFilesLesson(action) {
  const { courseId, lessonId } = action;
  try {
    const files = yield call(fetchFiles, { courseId, lessonId });
    yield put({
      type: Types.UPDATE_LESSON_FILES,
      files: files || [],
      course: courseId,
      lesson: lessonId,
    });
  } catch (error) {
    const { status, message } = yield sagaErrorHandle({
      sagaName: 'getFilesLesson',
      errorData: error,
      additionalInfos: action,
    });
    const msg = status === -1 ? 'Error on getFilesLesson' : message;
    yield put({
      type: Types.SET_COURSE_ERROR,
      errorType: 'current',
      error: { status, msg },
    });
  }
}

export function* getQuestionsLesson(action) {
  const { courseId, lessonId } = action;
  try {
    const [questionsRet, answersRet] = yield all([
      call(fetchQuestions, { courseId, lessonId }),
      call(fetchAnswers, { courseId, lessonId }),
    ]);
    const { data: questions } = questionsRet;
    const { data: answers } = answersRet;
    let questionsCompleted = !!questions.length;
    const questionsWithAnswers = (() => {
      if (questions.length) {
        const formatedQuestions = questions.map(question => {
          const answersQuestion =
            answers &&
            answers.filter(answer => answer.questionId === question.id);
          const lastAnswer =
            !!answersQuestion && answersQuestion.length
              ? answersQuestion.pop()
              : false;

          if (questionsCompleted && !lastAnswer) {
            questionsCompleted = false;
          }
          return {
            ...question,
            answer: {
              id: lastAnswer ? lastAnswer.id : null,
              text: lastAnswer ? lastAnswer.text : '',
            },
          };
        });
        return formatedQuestions;
      }
      return [];
    })();
    yield put({
      type: Types.UPDATE_LESSON_QUESTIONS,
      data: {
        questions: convertArrToObj(questionsWithAnswers, 'id') || {},
        questionsCompleted,
        questionsUpdating: false,
      },
      course: courseId,
      lesson: lessonId,
    });
  } catch (error) {
    const { status, message } = yield sagaErrorHandle({
      sagaName: 'getQuestionsLesson',
      dataError: error,
      additionalInfos: action,
    });
    const msg = status === -1 ? 'Error on getQuestionsLesson' : message;
    yield put({
      type: Types.SET_COURSE_ERROR,
      errorType: 'current',
      error: { status, msg },
    });
  }
}

export function* setLessonAnswers(action) {
  const { courseId, lessonId, questions } = action;

  try {
    const postAnswersQueue = questions.map(question => {
      const answerData = {
        questionId: question.id,
        text: question.answer.text || '',
      };
      const answerId = question.answer.id;
      return answerId
        ? call(updateAnswer, {
            courseId,
            lessonId,
            answerId,
            answerData,
          })
        : call(postAnswer, { courseId, lessonId, answerData });
    });
    yield put({
      type: Types.UPDATE_LESSON_QUESTIONS,
      data: {
        questionsUpdating: true,
      },
      course: courseId,
      lesson: lessonId,
    });
    const postQueueRet = yield all(postAnswersQueue);
    const updateAnswersQueue = postQueueRet.map(ret => {
      const { text, questionId } = ret.data;
      if (ret.status === 200) {
        return put({
          type: Types.UPDATE_LESSON_QUESTION_ANSWER,
          data: {
            courseId,
            lessonId,
            questionId,
            text,
          },
          course: courseId,
          lesson: lessonId,
        });
      }
      return false;
    });
    yield all(updateAnswersQueue);
    yield put({
      type: Types.UPDATE_LESSON_QUESTIONS,
      data: {
        questionsUpdating: false,
        questionsCompleted: true,
      },
      course: courseId,
      lesson: lessonId,
    });
  } catch (error) {
    const { status, message } = yield sagaErrorHandle({
      sagaName: 'setLessonAnswers',
      errorData: error,
      additionalInfos: action,
    });
    const msg = status === -1 ? 'Error on setLessonAnswers' : message;
    yield put({
      type: Types.SET_COURSE_ERROR,
      errorType: 'current',
      error: { status, msg },
    });
  }
}

export function* registerLessonAccessed(data) {
  yield call(AddLog, { actionId: 3, lessonId: data.lessonId });
}
